import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️  Supabase env vars missing. Check .env.local')
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder'
)

// ─── Auth helpers ──────────────────────────────────────────
export const auth = {
  signUp: (email, password) => supabase.auth.signUp({ email, password }),
  signIn: (email, password) => supabase.auth.signInWithPassword({ email, password }),
  signOut: () => supabase.auth.signOut(),
  getUser: () => supabase.auth.getUser(),
  onAuthChange: (cb) => supabase.auth.onAuthStateChange(cb),
  resetPassword: (email) => supabase.auth.resetPasswordForEmail(email, { redirectTo: 'https://app.peppermintfi.com/reset-password' }),
}

// ─── Database helpers ──────────────────────────────────────
export const db = {
  // Accounts
  getAccounts: (userId) =>
    supabase.from('accounts').select('*').eq('user_id', userId),
  
  // Transactions  
  getTransactions: (userId, limit = 50) =>
    supabase.from('transactions').select('*').eq('user_id', userId)
      .order('date', { ascending: false }).limit(limit),

  // Budgets
  getBudgets: (userId) =>
    supabase.from('budgets').select('*').eq('user_id', userId),
  upsertBudget: (budget) =>
    supabase.from('budgets').upsert(budget),

  // Waitlist
  addToWaitlist: (email) =>
    supabase.from('waitlist').insert({ email, created_at: new Date().toISOString() }),

  // User profile + plan
  getUserProfile: (userId) =>
    supabase.from('profiles').select('*').eq('id', userId).single(),
  updatePlan: (userId, plan) =>
    supabase.from('profiles').update({ plan }).eq('id', userId),
}
